module.exports = __webpack_public_path__ + "static/media/7.6ca974f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/7.jpg
// module id = 168
// module chunks = 0